import React from "react";

const Message = ({ message }) => {
    return (
        <div className="relative max-w-xl px-4 py-2 bg-violet-500 text-white rounded-full shadow">
            <span className="block">{message}</span>
        </div>
    );
};

export default Message;
